import {IHostingLogsState} from "../reducers/hosting-logs.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getLogsHostingState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingLogs);

export const getLogs = (websiteId: number, lines: number, logType: string) => createSelector(getLogsHostingState,
  (state: IHostingLogsState) =>
    (state.entities[websiteId] && state.entities[websiteId].entities) ? Object.values(state.entities[websiteId].entities) : []
);


export const getLogsMap = (websiteId: number) => createSelector(getLogsHostingState,
  (state: IHostingLogsState) =>
    state.entities[websiteId]
);

export const getLog = (websiteId: number) => createSelector(getLogsHostingState,
    (state: IHostingLogsState) =>
      state.entities[websiteId]
);

export const getLogsLoading = (websiteId: number) => createSelector(getLogsHostingState,
  (state: IHostingLogsState) =>
    state.entities[websiteId].loading
);

export const getLogsLoaded = (websiteId: number) => createSelector(getLogsHostingState,
  (state: IHostingLogsState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
